import Image from 'react-bootstrap/Image';
import clsx from "clsx";
import React from "react";
import { useHistory } from "react-router";
import * as ipoSelectors from "../../../../selectors/ipo";

function IPOItemComponent({ item}) {
  const history = useHistory();
  const id = ipoSelectors.getIPODetailID(item)
  const companyLogo = ipoSelectors.getIPODetailCompanyLogoFull(item)
  const stockCode = ipoSelectors.getIPODetailStockCode(item)
  const stockName = ipoSelectors.getIPODetailStockName(item)
  const pricePerShare = ipoSelectors.getIPODetailPricePerShare(item)
  const openDatetimeText = ipoSelectors.getIPODetailOpenDatetimeText(item)
  const closeDatetimeText = ipoSelectors.getIPODetailCloseDatetimeText(item)
  const onClickDetail = (detail) => {
    history.push(`/dashboard/e-ipo/detail/${id}`);
  };

  const onClickSubscribe = () => {
    history.push(`/dashboard/e-ipo/subscribe/${id}`);
  };

  return (
    <div className="ipo-component">
      <div className="ipo-top-component">
        <div className="ipo-logo">
          <Image src={companyLogo} rounded />
        </div>
        <div className="ipo-top-right-component">
          <div className="ipo-title">{stockName}</div>
          <div className="ipo-stockcode">{stockCode}</div>
        </div>
      </div>
      <div className="ipo-top-sec-component">
        <div className="ipo-light-title">Issues price per share</div>
        <div className="ipo-price">{pricePerShare}</div>
      </div>
      <hr></hr>
      <div className="ipo-top-sec-component">
        <div className="ipo-light-title">Open</div>
        <div className="ipo-time">{openDatetimeText}</div>
      </div>
      <div className="ipo-top-sec-component">
        <div className="ipo-light-title">Close</div>
        <div className="ipo-time">{closeDatetimeText}</div>
      </div>
      {/*<div className="ipo-top-sec-component mt-1">*/}
      {/*  <div className="ipo-light-title"></div>*/}
      {/*  <div className="ipo-left-time">4 hour 8 minutes left</div>*/}
      {/*</div>*/}
      <div className="ipo-top-sec-component mt-4">
        <div
          onClick={() => {
            onClickDetail("2223");
          }}
          className="pointer ipo-more-information"
        >
          More Information
        </div>
        <div>
          <button
            className={clsx("btn btn-primary btn-fill mt-2 mb-2")}
            onClick={() => onClickSubscribe("22233")}
          >
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
}

export default IPOItemComponent;